module.exports = __webpack_public_path__ + "static/media/file4.4974e0d5.jpg";